import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

interface ExcelExportOptions {
  fileName: string;
  sheetName?: string;
  columnHeaders: Record<string, string>;
  highlightColumns?: string[];
}

/**
 * עיצוב מרכזי לקובץ Excel (xlsx) עם דגשים ועמודות מותאמות.
 */
export async function exportToExcel(
  data: Record<string, any>[],
  { fileName, sheetName = 'Sheet1', columnHeaders, highlightColumns = [] }: ExcelExportOptions
) {
  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet(sheetName);

  // הגדרת עמודות בהתאם לכותרות
  ws.columns = Object.keys(columnHeaders).map((key) => ({
    header: columnHeaders[key],
    key,
    width: 20,
  }));

  // הוספת שורות מה־data
  data.forEach((item) => {
    ws.addRow(item);
  });

  // הדגשת עמודות בצבע צהוב
  highlightColumns.forEach((colKey) => {
    const col = ws.getColumn(colKey);
    col.eachCell((cell, rowNumber) => {
      if (rowNumber > 1) {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFFF00' },
        };
      }
    });
  });

  // שמירת הקובץ
  const buffer = await wb.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  saveAs(blob, fileName);
}
